import React from 'react';

const BooksIcon = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={60}
      height={60}
      viewBox='0 0 60 60'
      fill='none'
      {...props}
    >
      <g clipPath='url(#clip0_19680_25864)'>
        <path
          d='M15.3811 20.5387V28.2976C15.3811 29.3071 16.1993 30.1253 17.2088 30.1253H54.25C55.8258 30.1253 57.2531 29.4866 58.2862 28.4535C59.3192 27.4205 59.9579 25.9932 59.9579 24.4174C59.9579 21.2659 57.403 18.7109 54.25 18.7109H17.2088C16.1993 18.7111 15.3811 19.5293 15.3811 20.5387Z'
          fill='url(#paint0_linear_19680_25864)'
        />
        <path
          d='M17.2088 18.7109H31.5999C30.5905 18.7109 29.7723 19.5292 29.7723 20.5386V28.2975C29.7723 29.3069 30.5905 30.1252 31.5999 30.1252H17.2088C16.1993 30.1252 15.3811 29.3069 15.3811 28.2975V20.5386C15.3811 19.5292 16.1993 18.7109 17.2088 18.7109Z'
          fill='url(#paint1_linear_19680_25864)'
        />
        <path
          d='M17.2088 30.1253H31.2442L31.1985 30.0796C30.5118 29.9255 29.972 29.3858 29.8179 28.6991L19.8298 18.7109H17.2088C16.1993 18.7109 15.3811 19.5292 15.3811 20.5386V28.2975C15.3811 29.3069 16.1993 30.1253 17.2088 30.1253Z'
          fill='url(#paint2_linear_19680_25864)'
        />
        <path
          d='M16.0346 28.7425H53.8674C56.2557 28.7425 58.1918 26.8065 58.1918 24.4181C58.1918 22.0299 56.2558 20.0938 53.8674 20.0938H15.7916C14.8634 20.0938 14.1111 20.8461 14.1111 21.7742V26.8188C14.111 27.8813 14.9723 28.7425 16.0346 28.7425Z'
          fill='url(#paint3_linear_19680_25864)'
        />
        <path
          d='M57.6903 26.4375C56.9646 27.807 55.5253 28.7406 53.8674 28.7406H16.0346C14.9723 28.7406 14.1111 27.8794 14.1111 26.817V26.4375H57.6903Z'
          fill='url(#paint4_linear_19680_25864)'
        />
        <path
          d='M53.8674 28.7384H16.0346C14.9723 28.7384 14.1111 27.8772 14.1111 26.8149V24.4141H58.1917C58.1917 26.8023 56.2557 28.7384 53.8674 28.7384Z'
          fill='url(#paint5_linear_19680_25864)'
        />
        <path
          d='M57.7114 22.4375C58.0177 23.0309 58.1917 23.7036 58.1917 24.4174C58.1917 26.8056 56.2557 28.7417 53.8673 28.7417H16.0346C14.9723 28.7417 14.1111 27.8806 14.1111 26.8182V22.4375H57.7114Z'
          fill='url(#paint6_linear_19680_25864)'
        />
        <path
          d='M15.7607 20.0938H29.8291C29.7934 20.2365 29.7723 20.3849 29.7723 20.5386V28.2975C29.7723 28.4512 29.7934 28.5996 29.829 28.7422H16.0039C14.9415 28.7422 14.0803 27.881 14.0803 26.8187V21.7741C14.0802 20.8461 14.8326 20.0938 15.7607 20.0938Z'
          fill='url(#paint7_linear_19680_25864)'
        />
        <path
          d='M58.4236 43.2483V51.2143C58.4236 52.1411 57.6888 52.8963 56.7693 52.9283C56.759 52.9283 56.7489 52.9297 56.7373 52.9297C56.727 52.9297 56.7169 52.9311 56.7067 52.9311H17.9534C16.4562 52.9311 15.1555 52.0916 14.4979 50.8563C14.204 50.3063 14.0381 49.6792 14.0381 49.0143V45.4467C14.0381 44.7817 14.204 44.1547 14.4979 43.6061C14.5837 43.4416 14.6841 43.283 14.7933 43.1347C15.5062 42.1628 16.6556 41.5312 17.9535 41.5312H56.7069C57.6554 41.5314 58.4236 42.2996 58.4236 43.2483Z'
          fill='url(#paint8_linear_19680_25864)'
        />
        <path
          d='M58.4237 43.6095V50.8596H14.4979C14.204 50.3096 14.0381 49.6825 14.0381 49.0176V45.45C14.0381 44.785 14.204 44.158 14.4979 43.6094L58.4237 43.6095Z'
          fill='url(#paint9_linear_19680_25864)'
        />
        <path
          d='M17.5608 50.8563C17.2669 50.3063 17.101 49.6792 17.101 49.0143V45.4467C17.101 44.7817 17.2669 44.1547 17.5608 43.6061C17.6467 43.4416 17.747 43.283 17.8562 43.1347C18.5692 42.1628 19.7186 41.5312 21.0164 41.5312H19.7069C18.409 41.5312 17.2596 42.1627 16.5467 43.1347C16.4375 43.2831 16.3372 43.4416 16.2513 43.6061C15.9574 44.1547 15.7915 44.7817 15.7915 45.4467V49.0143C15.7915 49.6792 15.9574 50.3063 16.2513 50.8563C16.9089 52.0916 18.2097 52.9311 19.7068 52.9311H21.0163C19.5192 52.9311 18.2184 52.0916 17.5608 50.8563Z'
          fill='url(#paint10_linear_19680_25864)'
        />
        <path
          d='M24.8721 50.8563C24.5782 50.3063 24.4123 49.6792 24.4123 49.0143V45.4467C24.4123 44.7817 24.5782 44.1547 24.8721 43.6061C24.958 43.4416 25.0583 43.283 25.1675 43.1347C25.8804 42.1628 27.0298 41.5312 28.3277 41.5312H27.0182C25.7203 41.5312 24.5709 42.1627 23.858 43.1347C23.7488 43.2831 23.6484 43.4416 23.5625 43.6061C23.2687 44.1547 23.1028 44.7817 23.1028 45.4467V49.0143C23.1028 49.6792 23.2687 50.3063 23.5625 50.8563C24.2202 52.0916 25.521 52.9311 27.0181 52.9311H28.3276C26.8304 52.9311 25.5297 52.0916 24.8721 50.8563Z'
          fill='url(#paint11_linear_19680_25864)'
        />
        <path
          d='M56.7751 44.8499V52.8159C56.7751 52.8538 56.7722 52.8886 56.7693 52.9265C56.759 52.9265 56.7489 52.9279 56.7373 52.9279C56.727 52.9279 56.7169 52.9293 56.7067 52.9293H17.9534C16.4562 52.9293 15.1555 52.0898 14.4979 50.8545C14.204 50.3045 14.0381 49.6774 14.0381 49.0125V45.4448C14.0381 44.7799 14.204 44.1528 14.4979 43.6042C14.5837 43.4398 14.6841 43.2812 14.7933 43.1328H55.0584C55.5168 43.1328 55.9314 43.3118 56.2384 43.6042C56.57 43.9159 56.7751 44.3596 56.7751 44.8499Z'
          fill='url(#paint12_linear_19680_25864)'
        />
        <path
          d='M58.699 43.3512V51.1101C58.699 52.1196 57.8807 52.9378 56.8713 52.9378H31.0336C29.4578 52.9378 28.0305 52.2991 26.9974 51.266C25.9644 50.233 25.3257 48.8057 25.3257 47.2299C25.3257 44.0784 27.8806 41.5234 31.0336 41.5234H56.8713C57.8807 41.5236 58.699 42.3418 58.699 43.3512Z'
          fill='url(#paint13_linear_19680_25864)'
        />
        <path
          d='M58.0454 51.555H31.4161C29.0279 51.555 27.0918 49.619 27.0918 47.2306C27.0918 44.8424 29.0278 42.9062 31.4161 42.9062H58.2885C59.2166 42.9062 59.969 43.6586 59.969 44.5867V49.6313C59.9691 50.6937 59.1078 51.555 58.0454 51.555Z'
          fill='url(#paint14_linear_19680_25864)'
        />
        <path
          d='M27.5933 49.25C28.3189 50.6196 29.7582 51.5531 31.4161 51.5531H58.0454C59.1077 51.5531 59.9689 50.6919 59.9689 49.6295V49.25H27.5933Z'
          fill='url(#paint15_linear_19680_25864)'
        />
        <path
          d='M31.416 51.5586H58.0453C59.1077 51.5586 59.9689 50.6974 59.9689 49.6351V47.2344H27.0918C27.0918 49.6225 29.0278 51.5586 31.416 51.5586Z'
          fill='url(#paint16_linear_19680_25864)'
        />
        <path
          d='M27.572 45.25C27.2658 45.8434 27.0918 46.5161 27.0918 47.2299C27.0918 49.6181 29.0278 51.5542 31.4161 51.5542H58.0454C59.1078 51.5542 59.969 50.6931 59.969 49.6307V45.25H27.572Z'
          fill='url(#paint17_linear_19680_25864)'
        />
        <path
          d='M14.0381 39.8079V31.8419C14.0381 30.8937 14.8068 30.125 15.755 30.125H58.283C59.2313 30.125 60 30.8937 60 31.8419V39.8079C60 40.7562 59.2313 41.5249 58.283 41.5249H15.755C14.8068 41.525 14.0381 40.7563 14.0381 39.8079Z'
          fill='url(#paint18_linear_19680_25864)'
        />
        <path
          d='M14.0381 39.4458V32.1953H60.0001V39.4458H14.0381Z'
          fill='url(#paint19_linear_19680_25864)'
        />
        <path
          d='M52.7749 41.525V30.125H54.282V41.525H52.7749Z'
          fill='url(#paint20_linear_19680_25864)'
        />
        <path
          d='M49.1616 41.525V30.125H50.6687V41.525H49.1616Z'
          fill='url(#paint21_linear_19680_25864)'
        />
        <path
          d='M23.3694 41.525V30.125H24.8766V41.525H23.3694Z'
          fill='url(#paint22_linear_19680_25864)'
        />
        <path
          d='M19.7561 41.525V30.125H21.2632V41.525H19.7561Z'
          fill='url(#paint23_linear_19680_25864)'
        />
        <path
          d='M58.3515 33.4435C58.3515 32.4953 57.5828 31.7266 56.6346 31.7266H14.1066C14.0854 31.7266 14.0647 31.7289 14.0436 31.7297C14.0413 31.7662 14.0381 31.8024 14.0381 31.8396V39.8057C14.0381 40.754 14.8068 41.5227 15.755 41.5227H58.283C58.3042 41.5227 58.3249 41.5203 58.346 41.5195C58.3483 41.483 58.3515 41.4468 58.3515 41.4096V33.4435Z'
          fill='url(#paint24_linear_19680_25864)'
        />
        <path
          d='M15.4275 20.1346C15.398 20.2648 15.3811 20.3996 15.3811 20.5387V28.2976C15.3811 28.4141 15.3932 28.5276 15.4139 28.6381C15.6089 28.7047 15.8171 28.7423 16.0346 28.7423H29.8292C29.8256 28.7279 29.8211 28.7136 29.8178 28.699L21.2125 20.0938H15.7916C15.6664 20.0939 15.5449 20.1086 15.4275 20.1346Z'
          fill='url(#paint25_linear_19680_25864)'
        />
        <path
          d='M8.99625 53.2475L1.28589 51.2455C0.368012 51.0071 -0.182811 50.07 0.0555415 49.1521L10.7433 7.98902C10.9817 7.07114 11.9188 6.52031 12.8367 6.75867L20.5471 8.76067C21.465 8.99902 22.0158 9.9362 21.7774 10.8541L11.0897 52.017C10.8513 52.9349 9.91413 53.4857 8.99625 53.2475Z'
          fill='url(#paint26_linear_19680_25864)'
        />
        <path
          d='M8.65009 53.1527L1.63232 51.3306L13.183 6.84375L20.2008 8.66587L8.65009 53.1527Z'
          fill='url(#paint27_linear_19680_25864)'
        />
        <path
          d='M20.3931 16.183L9.35889 13.3181L9.73771 11.8594L20.7718 14.7243L20.3931 16.183Z'
          fill='url(#paint28_linear_19680_25864)'
        />
        <path
          d='M12.0952 48.144L1.06104 45.279L1.43974 43.8203L12.4739 46.6853L12.0952 48.144Z'
          fill='url(#paint29_linear_19680_25864)'
        />
        <path
          d='M13.0081 44.6283L1.97388 41.7634L2.3527 40.3047L13.3868 43.1696L13.0081 44.6283Z'
          fill='url(#paint30_linear_19680_25864)'
        />
        <path
          d='M13.9749 8.75085C13.057 8.51249 12.1199 9.06343 11.8815 9.9812L1.19386 51.1445C1.18856 51.1651 1.18562 51.1856 1.18115 51.2061C1.21586 51.2176 1.25021 51.2298 1.28609 51.2391L8.99645 53.2411C9.91421 53.4794 10.8515 52.9285 11.0899 52.0107L21.7776 10.8476C21.7829 10.827 21.7859 10.8065 21.7903 10.7859C21.7556 10.7745 21.7213 10.7623 21.6854 10.753L13.9749 8.75085Z'
          fill='url(#paint31_linear_19680_25864)'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_19680_25864'
          x1='40.3949'
          y1='17.0003'
          x2='33.1778'
          y2='32.6373'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#92F37F' />
          <stop offset={1} stopColor='#4AB272' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_19680_25864'
          x1='18.3353'
          y1='24.4181'
          x2='37.7432'
          y2='24.4181'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4AB272' stopOpacity={0} />
          <stop offset={1} stopColor='#009245' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_19680_25864'
          x1='31.4871'
          y1='37.0944'
          x2='12.2813'
          y2='18.8343'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4AB272' stopOpacity={0} />
          <stop offset={1} stopColor='#009245' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_19680_25864'
          x1='36.1513'
          y1='21.3955'
          x2='36.1513'
          y2='28.6054'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F9F7FC' />
          <stop offset={1} stopColor='#F0DDFC' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_19680_25864'
          x1='35.9807'
          y1='28.7076'
          x2='35.6277'
          y2='19.6189'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F0DDFC' stopOpacity={0} />
          <stop offset='0.2889' stopColor='#C8B7E0' stopOpacity='0.289' />
          <stop offset='0.5915' stopColor='#A595C8' stopOpacity='0.592' />
          <stop offset='0.8395' stopColor='#8F81B8' stopOpacity='0.84' />
          <stop offset={1} stopColor='#8779B3' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_19680_25864'
          x1='36.1513'
          y1='26.5324'
          x2='36.1513'
          y2='21.4884'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F0DDFC' stopOpacity={0} />
          <stop offset='0.2889' stopColor='#C8B7E0' stopOpacity='0.289' />
          <stop offset='0.5915' stopColor='#A595C8' stopOpacity='0.592' />
          <stop offset='0.8395' stopColor='#8F81B8' stopOpacity='0.84' />
          <stop offset={1} stopColor='#8779B3' />
        </linearGradient>
        <linearGradient
          id='paint6_linear_19680_25864'
          x1='36.1061'
          y1='24.0621'
          x2='36.0127'
          y2='20.8871'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F0DDFC' stopOpacity={0} />
          <stop offset='0.2889' stopColor='#C8B7E0' stopOpacity='0.289' />
          <stop offset='0.5915' stopColor='#A595C8' stopOpacity='0.592' />
          <stop offset='0.8395' stopColor='#8F81B8' stopOpacity='0.84' />
          <stop offset={1} stopColor='#8779B3' />
        </linearGradient>
        <linearGradient
          id='paint7_linear_19680_25864'
          x1='18.183'
          y1='24.418'
          x2='45.6284'
          y2='24.418'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F0DDFC' stopOpacity={0} />
          <stop offset='0.2889' stopColor='#C8B7E0' stopOpacity='0.289' />
          <stop offset='0.5915' stopColor='#A595C8' stopOpacity='0.592' />
          <stop offset='0.8395' stopColor='#8F81B8' stopOpacity='0.84' />
          <stop offset={1} stopColor='#8779B3' />
        </linearGradient>
        <linearGradient
          id='paint8_linear_19680_25864'
          x1='36.2308'
          y1='44.8284'
          x2='36.2308'
          y2='52.8308'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFDA45' />
          <stop offset={1} stopColor='#FFA425' />
        </linearGradient>
        <linearGradient
          id='paint9_linear_19680_25864'
          x1='36.2309'
          y1='45.632'
          x2='36.2309'
          y2='49.1996'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFDA45' />
          <stop offset={1} stopColor='#FFA425' />
        </linearGradient>
        <linearGradient
          id='paint10_linear_19680_25864'
          x1='18.404'
          y1='47.411'
          x2='18.404'
          y2='50.1792'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF7044' />
          <stop offset={1} stopColor='#F92814' />
        </linearGradient>
        <linearGradient
          id='paint11_linear_19680_25864'
          x1='25.7153'
          y1='47.411'
          x2='25.7153'
          y2='50.1792'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF7044' />
          <stop offset={1} stopColor='#F92814' />
        </linearGradient>
        <linearGradient
          id='paint12_linear_19680_25864'
          x1='35.4066'
          y1='48.5368'
          x2='35.4066'
          y2='41.4074'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFDA45' stopOpacity={0} />
          <stop offset={1} stopColor='#FCEE21' />
        </linearGradient>
        <linearGradient
          id='paint13_linear_19680_25864'
          x1='39.917'
          y1='41.1777'
          x2='45.8593'
          y2='54.0528'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFDA45' />
          <stop offset={1} stopColor='#FFA425' />
        </linearGradient>
        <linearGradient
          id='paint14_linear_19680_25864'
          x1='43.5305'
          y1='44.2079'
          x2='43.5305'
          y2='51.4179'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F9F7FC' />
          <stop offset={1} stopColor='#F0DDFC' />
        </linearGradient>
        <linearGradient
          id='paint15_linear_19680_25864'
          x1='43.7063'
          y1='51.3853'
          x2='44.0195'
          y2='43.3238'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F0DDFC' stopOpacity={0} />
          <stop offset='0.2889' stopColor='#C8B7E0' stopOpacity='0.289' />
          <stop offset='0.5915' stopColor='#A595C8' stopOpacity='0.592' />
          <stop offset='0.8395' stopColor='#8F81B8' stopOpacity='0.84' />
          <stop offset={1} stopColor='#8779B3' />
        </linearGradient>
        <linearGradient
          id='paint16_linear_19680_25864'
          x1='43.5304'
          y1='49.3525'
          x2='43.5304'
          y2='44.3086'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F0DDFC' stopOpacity={0} />
          <stop offset='0.2889' stopColor='#C8B7E0' stopOpacity='0.289' />
          <stop offset='0.5915' stopColor='#A595C8' stopOpacity='0.592' />
          <stop offset='0.8395' stopColor='#8F81B8' stopOpacity='0.84' />
          <stop offset={1} stopColor='#8779B3' />
        </linearGradient>
        <linearGradient
          id='paint17_linear_19680_25864'
          x1='43.5738'
          y1='46.9392'
          x2='43.663'
          y2='43.9041'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F0DDFC' stopOpacity={0} />
          <stop offset='0.2889' stopColor='#C8B7E0' stopOpacity='0.289' />
          <stop offset='0.5915' stopColor='#A595C8' stopOpacity='0.592' />
          <stop offset='0.8395' stopColor='#8F81B8' stopOpacity='0.84' />
          <stop offset={1} stopColor='#8779B3' />
        </linearGradient>
        <linearGradient
          id='paint18_linear_19680_25864'
          x1='37.0191'
          y1='30.125'
          x2='37.0191'
          y2='44.2377'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4A98F7' />
          <stop offset={1} stopColor='#0469BC' />
        </linearGradient>
        <linearGradient
          id='paint19_linear_19680_25864'
          x1='37.0191'
          y1='32.1953'
          x2='37.0191'
          y2='37.5288'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4A98F7' />
          <stop offset={1} stopColor='#0469BC' />
        </linearGradient>
        <linearGradient
          id='paint20_linear_19680_25864'
          x1='53.5284'
          y1='30.125'
          x2='53.5284'
          y2='38.5109'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFDA45' />
          <stop offset={1} stopColor='#FFA425' />
        </linearGradient>
        <linearGradient
          id='paint21_linear_19680_25864'
          x1='49.9152'
          y1='30.125'
          x2='49.9152'
          y2='38.5109'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFDA45' />
          <stop offset={1} stopColor='#FFA425' />
        </linearGradient>
        <linearGradient
          id='paint22_linear_19680_25864'
          x1='24.123'
          y1='30.125'
          x2='24.123'
          y2='38.5109'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFDA45' />
          <stop offset={1} stopColor='#FFA425' />
        </linearGradient>
        <linearGradient
          id='paint23_linear_19680_25864'
          x1='20.5098'
          y1='30.125'
          x2='20.5098'
          y2='38.5109'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFDA45' />
          <stop offset={1} stopColor='#FFA425' />
        </linearGradient>
        <linearGradient
          id='paint24_linear_19680_25864'
          x1='38.8313'
          y1='30.9701'
          x2='44.8967'
          y2='17.9615'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#18CFFC' stopOpacity={0} />
          <stop offset={1} stopColor='#65E1DC' />
        </linearGradient>
        <linearGradient
          id='paint25_linear_19680_25864'
          x1='25.3226'
          y1='29.1107'
          x2='11.1365'
          y2='19.5079'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F0DDFC' stopOpacity={0} />
          <stop offset='0.2889' stopColor='#C8B7E0' stopOpacity='0.289' />
          <stop offset='0.5915' stopColor='#A595C8' stopOpacity='0.592' />
          <stop offset='0.8395' stopColor='#8F81B8' stopOpacity='0.84' />
          <stop offset={1} stopColor='#8779B3' />
        </linearGradient>
        <linearGradient
          id='paint26_linear_19680_25864'
          x1='5.41133'
          y1='28.5722'
          x2='19.0725'
          y2='32.1145'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF7044' />
          <stop offset={1} stopColor='#F92814' />
        </linearGradient>
        <linearGradient
          id='paint27_linear_19680_25864'
          x1='7.41984'
          y1='29.0882'
          x2='12.5826'
          y2='30.4269'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF7044' />
          <stop offset={1} stopColor='#F92814' />
        </linearGradient>
        <linearGradient
          id='paint28_linear_19680_25864'
          x1='9.55513'
          y1='12.5888'
          x2='17.6727'
          y2='14.6936'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F9F7FC' />
          <stop offset={1} stopColor='#F0DDFC' />
        </linearGradient>
        <linearGradient
          id='paint29_linear_19680_25864'
          x1='1.26747'
          y1='44.5529'
          x2='9.385'
          y2='46.6577'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F9F7FC' />
          <stop offset={1} stopColor='#F0DDFC' />
        </linearGradient>
        <linearGradient
          id='paint30_linear_19680_25864'
          x1='2.17923'
          y1='41.0369'
          x2='10.2968'
          y2='43.1417'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#F9F7FC' />
          <stop offset={1} stopColor='#F0DDFC' />
        </linearGradient>
        <linearGradient
          id='paint31_linear_19680_25864'
          x1='9.45001'
          y1='29.8568'
          x2='0.694696'
          y2='24.9895'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF7044' stopOpacity={0} />
          <stop offset={1} stopColor='#FFA425' />
        </linearGradient>
        <clipPath id='clip0_19680_25864'>
          <rect width={60} height={60} fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BooksIcon;
